import React from 'react';
import { Link } from "gatsby";
import Layout from "../../layouts/en";
import eventCover from '../../images/event-designthinking.jpg';

export default function Home(props) {
  return (
    <Layout
      location={props.location}
      title="Design Thinking Workshop: Human-centered Approach to Innovation"
    >
      <div className="lg:py-20 py-10">
        <div className="container mx-auto px-4 lg:px-0">
          <nav class="mb-4">
            <Link to="/">Home</Link>
            <span class="mx-3 text-gray-700">/</span>
            <span class="text-gray-500">
              Design Thinking Workshop: Human-centered Approach to Innovation
            </span>
          </nav>

          <div className="mt-5">
            <div className="lg:flex">
              <div className="lg:w-96">
                <img src={eventCover} className="rounded" alt="" />
              </div>
              <div className="lg:flex-1 lg:ml-10">
                <h1 className="lg:text-2xl font-bold lg:mt-0 mt-5">
                  Design Thinking Workshop: Human-centered Approach to
                  Innovation
                </h1>

                <div className="mt-5 leading-loose">
                  <ul className="list-disc ml-5">
                    <li>
                      Students will develop and apply human-centric innovation
                      to create new value through hands-on exercises in the
                      workshop.
                    </li>
                    <li>
                      The workshop consists of four modules: 1) Innovative and
                      creative confidence; 2) Introducing Design Thinking –
                      concept and mindset; 3) Experience innovation – practical
                      tools of Design Thinking; and 4) Applying Design Thinking
                      in daily life.
                    </li>
                  </ul>
                  <div className="mt-5 border-t pt-5">
                    <div className="lg:flex lg:items-center">
                      <label className="lg:w-48 text-gray-500">
                        Date / Time:
                      </label>
                      <div className="lg:flex-1">2pm - 5:30pm, 30 May</div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">Speakers:</label>
                      <div className="lg:flex-1">
                        Mr Yuen Tam, Senior Innovation Consultant, Education for Good & 3 Facilitators
                      </div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">Venue:</label>
                      <div className="lg:flex-1">Online via Zoom</div>
                    </div>
                    <div className="lg:flex mt-3">
                      <label className="lg:w-48 text-gray-500">Capacity:</label>
                      <div className="lg:flex-1">
                        40
                      </div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">
                        Registration Deadline:
                      </label>
                      <div className="lg:flex-1">25 May</div>
                    </div>
                    <p className="mt-5">
                      Limited seats are available and the activity registration
                      will be on a first-come-first-serve basis. The activity
                      Zoom link will be sent to the successful registrants by
                      email one day prior to the activity day.
                    </p>
                    <a
                      href="https://eduhk.au1.qualtrics.com/jfe/form/SV_0wiudOzAT7dhYBo"
                      className="cta mt-5 inline-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Register
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};